module.exports = __webpack_public_path__ + "static/img/aomen.195db84.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/aomen.png
// module id = AoL+
// module chunks = 1